module.exports = __webpack_public_path__ + "static/media/rehau_delight.812706de.png";